import { shallow } from 'zustand/shallow'

import ListSalesCommissionReport from '../components/list-sales-commission.component'
import { SearchFormReportPeriod } from '../components/search-form-report-period.component'
import { useReportStore } from '../useReportsStore'

export function SalesComissionInterface() {
  const { loading, jsonSalesCommission } = useReportStore(
    (state) => ({
      loading: state.loading,
      jsonSalesCommission: state.jsonSalesCommission,
    }),
    shallow,
  )

  return (
    <div>
      <SearchFormReportPeriod reportType="Commission" />
      {!loading && !!jsonSalesCommission && <ListSalesCommissionReport />}
    </div>
  )
}
